import { render, staticRenderFns } from "./StaffsListTable.vue?vue&type=template&id=1f66e443&scoped=true&"
import script from "./StaffsListTable.vue?vue&type=script&lang=js&"
export * from "./StaffsListTable.vue?vue&type=script&lang=js&"
import style0 from "./StaffsListTable.vue?vue&type=style&index=0&id=1f66e443&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f66e443",
  null
  
)

export default component.exports